export default "__VITE_ASSET__BcBAq6Ae__"